import { jsx as e, jsxs as m } from "react/jsx-runtime";
import { tv as o } from "tailwind-variants";
import { H as c } from "./chunks/index-UjijAVoZ.js";
import n from "./Jumbotron.js";
const i = o({
  base: ["text-lg"]
}), N = ({
  children: s,
  className: a,
  icon: t,
  heading: l,
  headingLevel: r = "1"
}) => /* @__PURE__ */ e(n, { className: "px-5", children: /* @__PURE__ */ m("div", { className: "container-md flex flex-col gap-6 py-9 text-center", children: [
  t && /* @__PURE__ */ e("span", { className: "text-4xl", children: t }),
  /* @__PURE__ */ e(
    c,
    {
      className: "text-blue-500",
      level: "1",
      tagName: `h${r}`,
      children: l
    }
  ),
  /* @__PURE__ */ e("div", { className: i({ class: a }), children: s })
] }) });
export {
  N as default
};
